import React from "react";
import {
    Box,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Table,
    Paper
} from '@material-ui/core';
export default class ComponentToPrint extends React.Component {
    render() {
        const SearchData = this.props.SearchData;
        const mappingData = this.props.mappingData;
        const applicableDate = this.props.applicableDate;
        const totalApprovedAmount = this.props.totalApprovedAmount;
        return (
            <div>
                <div style={{ width: '1093px', height: '1059px', padding: '20px', marginBottom: "14rem" }}>
                <h2><center><u>Advance Payment Report</u></center></h2>
                <div>&nbsp;</div>
                <h3><center>{SearchData.groupName} - {SearchData.factoryName}</center></h3>
                <h3><center>{SearchData.routeName ? 'Route :'+ SearchData.routeName : 'Route :' + 'All Routes' }</center></h3>
                <h3><center> From Date : {SearchData.startDate} - To Date :{SearchData.endDate}</center></h3>
                <h3><center> Applicable Month : {applicableDate}</center></h3>
                <div>&nbsp;</div>
                
                <div>
                    {mappingData && mappingData.length > 0 ? (
                    <Box display="flex" justifyContent="flex-end" p={2}>
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center" style={{ border: "1px solid black" ,height: "20px" ,padding: "4px"}}>Date</TableCell>
                                        <TableCell align="center" style={{ border: "1px solid black" ,height: "20px" ,padding: "4px"}}>Code</TableCell>
                                        <TableCell align="center" style={{ border: "1px solid black" ,height: "20px" ,padding: "4px"}}>Reg No</TableCell>
                                        <TableCell align="center" style={{ border: "1px solid black" ,height: "20px" ,padding: "4px"}}>Customer</TableCell>
                                        <TableCell align="center" style={{ border: "1px solid black" ,height: "20px" ,padding: "4px"}}>Amount</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {mappingData.map((group, index) => (
                                        <React.Fragment key={index}>
                                            <TableRow>
                                                <TableCell colSpan={5} align="center" style={{ fontWeight: "bold", border: "1px solid black" ,height: "20px" ,padding: "4px"}}>
                                                    {group.routeName}
                                                </TableCell>
                                            </TableRow>
                                            {group.records.map((rec, idx) => (
                                                <TableRow key={`${index}-${idx}`}>
                                                    <TableCell style={{ border: "1px solid black" ,height: "20px" ,padding: "4px"}}>{new Date(rec.issuingDate).toLocaleDateString('en-CA')}</TableCell>
                                                    <TableCell style={{ border: "1px solid black" ,height: "20px" ,padding: "4px"}}>{rec.referenceNumber}</TableCell>
                                                    <TableCell style={{ border: "1px solid black" ,height: "20px" ,padding: "4px"}}>{rec.registrationNumber}</TableCell>
                                                    <TableCell style={{ border: "1px solid black" ,height: "20px" ,padding: "4px"}}>{rec.fullName}</TableCell>
                                                    <TableCell align="right" style={{ border: "1px solid black",height: "20px" ,padding: "4px"}}>{rec.approvedAmount.toLocaleString(undefined, { minimumFractionDigits: 2 })}</TableCell>
                                                </TableRow>
                                            ))}
                                            <TableRow>
                                                <TableCell colSpan={4} align="left" style={{ border: "1px solid black" , fontWeight: "bold",height: "20px" ,padding: "4px"}}><b>Route Total: ({group.records.length})</b></TableCell>
                                                <TableCell align="right" style={{ border: "1px solid black", fontWeight: "bold",height: "20px" ,padding: "4px"}}><b>{group.totalApprovedAmount.toLocaleString(undefined, { minimumFractionDigits: 2 })}</b></TableCell>
                                            </TableRow>
                                        </React.Fragment>
                                    ))}
                                    <TableRow>
                                        <TableCell colSpan={4} align="left" style={{ border: "1px solid black" ,height: "20px" ,padding: "4px"}}><b>Grand Total:</b></TableCell>
                                        <TableCell align="right" style={{ border: "1px solid black" ,height: "20px" ,padding: "4px"}}><b>{totalApprovedAmount.toLocaleString(undefined, { minimumFractionDigits: 2 })}</b></TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                ) : null}
                </div>
                <div>&nbsp;</div>
                <h3><center>***** End of List *****</center></h3>
                </div>
            </div>
        );

    }

}
